import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { MedicalHistoryModel } from 'src/app/models/MedicalHistoryModel';
import { MedicalHistoryService } from 'src/app/services/MedicalHistoryService';
import swal from 'sweetalert2';


@Component({
  selector: 'app-medical-history-vtab',
  templateUrl: './medical-history-vtab.component.html',
  styleUrls: ['./medical-history-vtab.component.css']
})
export class MedicalHistoryVTabComponent implements OnInit {
  diabetescheck = false;
  diabetes = '' ;
  diabetessince = 0 ;
  diabetesdays = '' ;
  diabetescontrol = '' ;
  haypercheck = false;
  hayper = '' ;
  haypersince = 0 ;
  hayperdays = '' ;
  haypercontrol = '' ;
  hepacheck = false;
  hepa = '' ;
  hepasince = 0 ;
  hepadays = '' ;
  hepacontrol = '' ;
  bilhcheck =false;
  bilh = '' ;
  bilhsince = 0 ;
  bilhdays = '' ;
  bilhcontrol = '' ;
  cardcheck = false;
  card = '' ;
  cardsince = 0 ;
  carddays = '' ;
  cardcontrol = '' ;
  auto = '' ;
  autosince = 0 ;
  autodays = '' ;
  autocontrol = '' ;
  allergy = '' ;
  allergysince = 0 ;
  allergydays = '' ;
  allergycontrol = '' ;
  othersM = '' ;
  othersMcheck = false;
  otherssince = 0 ;
  othersdays = '' ;
  otherscontrol = '' ;

  MHColor =  'rgb(3, 0, 98)';
  MHColor1 = 'rgb(3, 0, 98)';
  MHColor2 = 'rgb(3, 0, 98)';
  MHColor3 = 'rgb(3, 0, 98)';
  MHColor4 = 'rgb(3, 0, 98)';
  MHColor5 = 'rgb(3, 0, 98)';
  MHColor6 = 'rgb(3, 0, 98)';
  MHColor7 = 'rgb(3, 0, 98)';
  constructor(public medicalhistoryService : MedicalHistoryService,
              public medicalhistory : MedicalHistoryModel,
    public storage: LocalStorageService,
  ) { }
  Patientcode = '';
  Patientname = '';
  visitdate  = '';



  ngOnInit(): void {
        this.Patientcode = this.storage.retrieve('stgPatientCode');
        this.Patientname = this.storage.retrieve('stgPatientName');
        this.visitdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
        this.retriveMedicalHistory();
  }
/////////////======= Medical History Data ========////////
retriveMedicalHistory() {

  this.medicalhistoryService
    .getMHistory(this.Patientcode, this.storage.retrieve('stgcompCode'))
    .subscribe({

      next: (data: MedicalHistoryModel | null) => {

        // ✅ NO RECORD FOUND
        // if (!data) {
        //   this.New_Data();
        //   return;
        // }

        // ✅ RECORD FOUND → normal mapping
        this.diabetescheck = data.diabetes === 'True';
        this.diabetessince = data.diabetessince;
        this.diabetesdays = data.diabetesdays ?? '';
        this.diabetescontrol = data.diabetescontrol;

        this.haypercheck = data.hayper === 'True';
        this.haypersince = data.haypersince;
        this.hayperdays = data.hayperdays ?? '';
        this.haypercontrol = data.haypercontrol;

        this.hepacheck = data.hepa === 'True';
        this.hepasince = data.hepasince;
        this.hepadays = data.hepadays ?? '';
        this.hepacontrol = data.hepacontrol;

        this.bilhcheck = data.bilh === 'True';
        this.bilhsince = data.bilhsince;
        this.bilhdays = data.bilhdays ?? '';
        this.bilhcontrol = data.bilhcontrol;

        this.cardcheck = data.card === 'True';
        this.cardsince = data.cardsince;
        this.carddays = data.carddays;
        this.cardcontrol = data.cardcontrol;

        this.allergy = data.allergy;
        this.allergysince = data.allergysince;
        this.allergydays = data.allergydays;
        this.allergycontrol = data.allergycontrol;

        this.othersMcheck = data.others === 'True';
        this.othersM = data.others;
        this.otherssince = data.otherssince;
        this.othersdays = data.othersdays;
        this.otherscontrol = data.otherscontrol;
      },

      error: (error) => {

        // ✅ If backend returns 404 → create new data
        if (error.status === 404) {
         
          return;
        }

        console.error('Error fetching medical history', error);
      }
    });
}

  Save_MedicalHistory(){
  
      this.medicalhistory.patientcode = this.Patientcode ;
      if(this.diabetescheck == true){this.medicalhistory.diabetes = 'True'}else{this.medicalhistory.diabetes = 'False'} ;
      this.medicalhistory.diabetessince = this.diabetessince ;
      this.medicalhistory.diabetesdays = this.diabetesdays ;
      this.medicalhistory.diabetescontrol = this.diabetescontrol ;
      
      if(this.haypercheck == true){this.medicalhistory.hayper = 'True'}else{this.medicalhistory.hayper = 'False'} ;
      this.medicalhistory.haypersince = this.haypersince ;
      this.medicalhistory.hayperdays = this.hayperdays ;
      if(this.haypercontrol === null)
        {this.haypercontrol = ''}
      else
        {
          this.medicalhistory.haypercontrol = this.haypercontrol
        };
      
      if(this.hepacheck == true){this.medicalhistory.hepa = 'True'}else{this.medicalhistory.hepa = 'False'} ;
      this.medicalhistory.hepasince = this.hepasince ;
      this.medicalhistory.hepadays = this.hepadays ;
       if(this.hepacontrol === null)
        {this.hepacontrol = ''}
       else
        {this.medicalhistory.hepacontrol = this.hepacontrol};
      //this.medicalhistory.hepacontrol = this.hepacontrol;

      if(this.bilhcheck == true){this.medicalhistory.bilh = 'True'}else{this.medicalhistory.bilh = 'False'} ;
      this.medicalhistory.bilhsince = this.bilhsince ;
      this.medicalhistory.bilhdays = this.bilhdays ;
      if(this.bilhcontrol === null)
        {this.bilhcontrol = ''}
      else
        {
          this.medicalhistory.bilhcontrol = this.bilhcontrol
        };
      //this.medicalhistory.bilhcontrol = this.bilhcontrol ;
      
      if(this.cardcheck == true){this.medicalhistory.card = 'True'}else{this.medicalhistory.card = 'False'} ;
      this.medicalhistory.cardsince = this.cardsince ;
      this.medicalhistory.carddays = this.carddays ;
      if(this.cardcontrol === null)
        {this.cardcontrol = ''}
      else
        {
          this.medicalhistory.cardcontrol = this.cardcontrol
        };
      //this.medicalhistory.cardcontrol = this.cardcontrol ;

      this.medicalhistory.auto = 'False' ;
      this.medicalhistory.autosince = this.autosince ;
      this.medicalhistory.autodays = this.autodays ;
      if(this.autocontrol === null)
        {this.autocontrol = ''}
      else
        {
          this.medicalhistory.autocontrol = this.autocontrol
        };
      //this.medicalhistory.autocontrol = this.autocontrol ;

      this.medicalhistory.allergy = 'False' ;
      this.medicalhistory.allergysince = this.allergysince ;
      this.medicalhistory.allergydays = this.allergydays ;
            if(this.allergycontrol === null)
        {this.allergycontrol = ''}
      else
        {
          this.medicalhistory.allergycontrol = this.allergycontrol
        };
      //this.medicalhistory.allergycontrol = '' ;

      if(this.othersMcheck == true){this.medicalhistory.others = 'True'}else{this.medicalhistory.others = 'False'} ;
      this.medicalhistory.otherssince = this.otherssince ;
      this.medicalhistory.othersdays = this.othersdays ;
     if(this.otherscontrol === null)
        {this.otherscontrol = ''}
      else
        {
          this.medicalhistory.otherscontrol = this.otherscontrol
        };
      //this.medicalhistory.otherscontrol = this.otherscontrol ;
      this.medicalhistory.userid = this.storage.retrieve('stguserId');
      this.medicalhistory.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.medicalhistory.compcode = this.storage.retrieve('stgcompCode');
debugger;
      this.medicalhistoryService.AddMHistory(this.medicalhistory).subscribe(data => {

      this.mesgSave();

    },

      error => { alert(error); console.log("Diom");}

    );

  }
    mesgSave() {
              swal({
              title: 'Your work has been saved',
  
              type: 'success',
              showConfirmButton: false,
  
              timer: 1500
              });
            }

          }
